
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import ReportTimeRangeFilter from '@/components/ReportTimeRangeFilter.vue'
import AiReportChartTypeSelect from '@/components/AiReportChartTypeSelect.vue'
import AiReportChat from '@/components/AiReportChat.vue'
import { ReportFilter, ReportFilterType } from '@/model/models'

export default defineComponent({
  name: 'AiReport',
  components: { Header, ReportTimeRangeFilter, AiReportChartTypeSelect, AiReportChat },
  data() {
    return {
      dateRangeFilter: new ReportFilter({ name: 'dateRange', title: 'Date range', type: ReportFilterType.TimeRange }),
      dateRangeEnabled: false,
      dateFrom: null as number | null,
      dateTo: null as number | null,
      dateRangeLabel: '',
      chartTypeEnabled: false,
      chartType: null as string | null
    }
  },
  methods: {
    onDateRangeChanged(data: any) {
      const [from, to] = (data.value as string).split(',').map(Number)
      this.dateFrom = from
      this.dateTo = to
      this.dateRangeLabel = new Date(from * 1000).toLocaleDateString() + ' - ' + new Date(to * 1000).toLocaleDateString()
    },
    removeDateRange() {
      this.dateRangeEnabled = false
      this.dateFrom = null
      this.dateTo = null
      this.dateRangeLabel = ''
    },
    onChartTypeChanged(type: string) {
      this.chartType = type
    },
    removeChartType() {
      this.chartTypeEnabled = false
      this.chartType = null
    },
    onNewChat() {
      const chat = this.$refs.chat as InstanceType<typeof AiReportChat>
      chat?.reset()
    }
  }
})
